import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import './Datagrid.scss'

class Datagrid extends Component {

    render() {
        const { columns, data, onGridReady, children, ...rest } = this.props;
        return (
            <div
                className="ag-theme-balham-dark"
                style={{
                    height: '100%',
                    width: '100%',
                    minHeight: 'calc(50vh - 20px)'
                }}
            >
                <AgGridReact
                    reactNext={true}
                    columnDefs={columns}
                    rowData={data}
                    animateRows={true}
                    //debug={true}
                    refreshCells= {true}
                    onGridReady={(params) => {
                        this.onGridReady(params);
                        if (onGridReady) {
                            onGridReady(params);
                        }
                    }}
                    {...rest} >
                    {children}
                </AgGridReact>
            </div>
        );
    }

    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    }

};

export default Datagrid;